var _ellipse, _path, _path2, _ellipse2, _ellipse3, _g, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlant2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 120,
    viewBox: "0 0 86 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6441,
    cy: 116.463,
    rx: 20.6402,
    ry: 3.49217,
    fill: "#710120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 108.089L29.9768 90.9158C29.9476 90.7932 29.9326 90.664 29.9326 90.5338C29.9326 89.9046 30.2744 89.3945 30.6959 89.3945H60.5915C60.6787 89.3945 60.7652 89.4168 60.8474 89.4605C61.2446 89.6715 61.4519 90.3231 61.3106 90.9158L58.8268 108.089C58.8268 108.089 58.8905 116.459 45.9519 116.459C33.0132 116.459 32.4606 108.089 32.4606 108.089Z",
    fill: "#B7B7B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 108.089L29.9768 90.9158C29.9476 90.7932 29.9326 90.664 29.9326 90.5338C29.9326 89.9046 30.2744 89.3945 30.6959 89.3945H60.5915C60.6787 89.3945 60.7652 89.4168 60.8474 89.4605C61.2446 89.6715 61.4519 90.3231 61.3106 90.9158L58.8268 108.089C58.8268 108.089 57.3502 114.131 45.9519 114.131C34.5536 114.131 32.4606 108.089 32.4606 108.089Z",
    fill: "#EDEDEE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6448,
    cy: 90.269,
    rx: 15.7112,
    ry: 3.49217,
    fill: "#B7B7B9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6441,
    cy: 91.4355,
    rx: 13.8628,
    ry: 2.32811,
    fill: "#32312B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4345 25.5338L72.1388 23.6507L77.7948 27.5875C74.0138 32.284 70.0857 37.3497 69.7226 43.3367C69.6001 45.2885 69.3445 47.139 68.9269 48.8701L60.3093 50.6323L58.0651 51.0904L60.9425 51.3172L68.0381 51.8817C67.5417 53.26 66.9581 54.5555 66.2754 55.7537C63.0934 61.394 57.5048 77.7714 51.4217 78.6877C51.4217 78.6877 51.4217 78.6877 51.4163 78.6877C51.2299 78.3359 42.5143 62.1898 50.5615 37.4983C51.6325 34.2223 53.047 31.1685 54.6962 28.3557C54.7506 28.2589 54.8043 28.1705 54.8587 28.0782C64.6304 11.6311 82.3465 3.65961 84.7728 12.043C86.1031 16.6276 83.1033 20.9442 79.4345 25.5338Z",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2747 55.7521C61.477 70.2751 57.5042 77.7699 51.421 78.6861C51.421 78.6861 51.421 78.6861 51.4156 78.6861C51.1701 78.6861 37.839 78.506 49.4373 39.0416C50.4091 35.738 52.9728 31.2593 54.6955 28.3541C54.7499 28.2573 54.8036 28.169 54.858 28.0767C54.3324 32.2357 54.0922 38.431 56.027 44.0426C56.027 44.0426 57.3572 47.2027 60.3086 50.6307L58.0645 51.0888L60.9418 51.3156C62.3706 52.8656 64.1387 54.4431 66.2747 55.7521Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9442 41.2314L49.9332 44.6392L54.0362 43.468C54.3456 55.3075 52.077 66.5623 45.9813 67.6007C37.894 68.9885 33.3657 48.6604 33.085 34.3428L38.8659 35.7633L33.1369 32.1958C33.1644 31.306 33.2182 28.7239 33.2928 27.9337C34.0927 19.5115 37.0984 10.9266 42.4911 5.58057C45.8475 10.8118 48.714 16.8371 50.7437 22.8044C52.4485 27.7885 53.593 34.5072 53.9442 41.2314Z",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2891 27.9314L50.7442 22.7999C48.7204 16.8376 45.8431 10.8129 42.4903 5.58057C37.1018 10.9238 34.0871 19.5143 33.2891 27.9314Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2773 27.9335C36.0878 22.8717 40.631 20.4928 45.5022 18.8483L44.0041 11.1414L47.5278 18.2079C54.7859 16.0585 62.4048 14.9414 66.1118 8.77033C66.9899 7.31438 66.2898 5.49035 65.0103 4.31411C63.8205 3.21497 62.1587 2.23289 60.2102 1.55585L51.5663 4.01414L56.3455 0.685766C47.385 -0.330081 35.6762 5.11441 33.2773 27.9335Z",
    fill: "#FED3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1117 75.8205C37.5003 77.5995 29.7506 68.1473 23.7928 55.7663C23.4541 55.0443 23.1143 54.3222 22.7756 53.5771C22.134 52.1554 21.5164 50.6995 20.9364 49.221L24.6572 48.6504L19.8116 46.2523C17.1995 38.9399 15.4882 31.3539 15.5001 24.8711L33.3405 28.2344C37.5833 34.7943 41.0425 43.9065 43.0925 52.4205L41.2593 57.4007L43.8284 55.7326C45.8629 65.85 45.6765 74.4523 42.1117 75.8205Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3402 28.2333C33.3402 28.2333 29.4737 27.5754 25.4418 29.8327L19.2099 26.613L24.0273 30.7597C22.9007 31.5971 21.7957 32.6861 20.788 34.1274C20.6721 34.2912 20.5562 34.4443 20.4403 34.6081C18.9799 33.5646 17.0613 32.2725 16.8749 32.152L19.1143 36.3342C11.9822 44.8661 2.71884 46.7374 4.91999 38.4396C5.37098 36.7411 5.78791 34.7898 6.50172 32.5899L10.8891 29.7145L7.28183 30.2751C7.53689 29.58 7.63067 29.4044 7.87258 29.0184C10.0056 25.6855 14.003 23.8299 18.1329 24.0106C23.3111 24.2492 30.835 25.1261 33.3402 28.2333Z",
    fill: "#FED3B5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9425 13.4355C69.3157 20.3601 54.6164 34.2091 48.833 91.4274",
    stroke: "#FFEADB",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6387 18.0933C44.2156 37.435 48.5964 79.2971 45.5041 92.0109",
    stroke: "#FFEADB",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6885 30.895C28.3426 40.8065 42.0945 66.7888 43.869 91.426",
    stroke: "#FFEADB",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.6414,
    height: 79.1559,
    fill: "white",
    transform: "translate(0.358398 0.0507812)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant2);
export default __webpack_public_path__ + "static/media/plant2.3d4a8a52accea2670def4c69c115900c.svg";
export { ForwardRef as ReactComponent };